export default __webpack_public_path__ + "74c18b69d358a1f17c72596e77c44a9f.ico";